var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreemapChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "72px",
    viewBox: "0 0 74 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4BC32349-694A-48E1-8361-3E1EB6BABB1B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.40738,0 C52.39098,0 54.00018,1.6092 54.00018,3.5928 L54.00018,3.5928 L54.00018,28.8072 C54.00018,30.7908 52.39098,32.4 50.40738,32.4 L50.40738,32.4 L43.19298,32.4 C41.20758,32.4 39.60018,30.7908 39.60018,28.8072 L39.60018,28.8072 L39.60018,3.5928 C39.60018,1.6092 41.20758,0 43.19298,0 L43.19298,0 Z M10.8072,0.00018 C12.7908,0.00018 14.4,1.60758 14.4,3.59298 L14.4,3.59298 L14.4,18.00738 C14.4,19.99098 12.7908,21.60018 10.8072,21.60018 L10.8072,21.60018 L3.5928,21.60018 C1.6092,21.60018 3.19744231e-15,19.99098 3.19744231e-15,18.00738 L3.19744231e-15,18.00738 L3.19744231e-15,3.59298 C3.19744231e-15,1.60758 1.6092,0.00018 3.5928,0.00018 L3.5928,0.00018 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8072,25.20018 C12.7908,25.20018 14.4,26.80758 14.4,28.79298 L14.4,28.79298 L14.4,50.40738 C14.4,52.39098 12.7908,54.00018 10.8072,54.00018 L10.8072,54.00018 L3.5928,54.00018 C1.6092,54.00018 3.19744231e-15,52.39098 3.19744231e-15,50.40738 L3.19744231e-15,50.40738 L3.19744231e-15,28.79298 C3.19744231e-15,26.80758 1.6092,25.20018 3.5928,25.20018 L3.5928,25.20018 Z M50.40738,36 C52.39098,36 54.00018,37.6092 54.00018,39.5928 L54.00018,39.5928 L54.00018,50.4072 C54.00018,52.3908 52.39098,54 50.40738,54 L50.40738,54 L21.59298,54 C19.60758,54 18.00018,52.3908 18.00018,50.4072 L18.00018,50.4072 L18.00018,39.5928 C18.00018,37.6092 19.60758,36 21.59298,36 L21.59298,36 Z M32.40738,3.19744231e-15 C34.39098,3.19744231e-15 36.00018,1.6092 36.00018,3.5928 L36.00018,3.5928 L36.00018,28.8072 C36.00018,30.7908 34.39098,32.4 32.40738,32.4 L32.40738,32.4 L21.59298,32.4 C19.60758,32.4 18.00018,30.7908 18.00018,28.8072 L18.00018,28.8072 L18.00018,3.5928 C18.00018,1.6092 19.60758,3.19744231e-15 21.59298,3.19744231e-15 L21.59298,3.19744231e-15 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.2-WebPageBuilder-EmptyWidgets",
    transform: "translate(-564.000000, -706.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Treemap",
    transform: "translate(336.000000, 536.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Treemap-Chart/40dp",
    transform: "translate(228.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(8.999820, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-2)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000000, -9.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple",
    transform: "translate(8.999820, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Light",
    mask: "url(#mask-4)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000000, -9.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 115.2,
    height: 115.2
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreemapChart);
export default __webpack_public_path__ + "static/media/treemapChart.dfe8041a4ebf82626afad71dd96129e8.svg";
export { ForwardRef as ReactComponent };